// Arabic module 11 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enCredentials } from './en-credentials.ts';
import type { Message } from './types.ts';

export const arCredentials: { readonly [K in keyof typeof enCredentials]: Message } = {
  'cred.api.issueBlocked': 'لا يمكن طلب بيانات الاعتماد هذه الآن. راجِع العوائق المذكورة.',
  'cred.api.credentialExists': 'لدى هذا الشخص (أو هذه البطاقة) بيانات اعتماد قد تمنح الدخول. عالِجها قبل طلب أخرى.',
  'cred.api.notLive': 'لم تعد بيانات الاعتماد هذه تمنح الدخول، فلا يوجد ما يُلغى.',
  'cred.api.notRetryable': 'يمكن إعادة طلب بيانات اعتماد فاشلة فقط ولم يُطلب إلغاؤها.',
  'cred.api.operationResolved': 'تمت معالجة هذا البند بالفعل.',
  'cred.api.notUnknown': 'تنطبق القراءة العكسية فقط على عملية نتيجتها غير معروفة.',
  'cred.api.readBackUnsupported': 'لا يستطيع هذا الموصل قراءة بيانات الاعتماد. تحقّق من نظام التحكم بالدخول مباشرة وسجّل ما وجدته.',
  'cred.api.readBackRunning': 'تجري قراءة عكسية لهذا البند. انتظر نتيجتها.',
  'cred.api.decisionNotApplicable': 'هذا القرار لا ينطبق على هذه العملية في حالتها الحالية.',
  'cred.api.revokeOpen': 'يوجد إلغاء مفتوح بالفعل لبيانات الاعتماد هذه.',
  'cred.api.connectorExists': 'لهذا الموقع موصل دخول نشط بالفعل. عطّله أولًا.',
  'cred.api.mappingRetired': 'هذا الربط متقاعد بالفعل.',
  'cred.api.simulatorOnly': 'لا يمكن إرسال أحداث محاكاة إلا إلى محاكي التطوير.',
  'cred.api.templateNotDraft': 'لا يمكن تغيير إلا قالب مسودة. أنشئ إصدارًا جديدًا بدلًا من ذلك.',
  'cred.v.adapterUnavailable': 'لا يوجد لهذه المنصة محوّل معتمد بعد. تبقى غير متاحة حتى تنجح اختبارات التوافق.',
  'cred.v.locationUnknown': 'اختر موقعًا نشطًا في هذا الموقع.',
  'cred.v.mappingExists': 'لهذا الموقع ربط نشط بالفعل. أوقفه أولًا.',
  'cred.v.credentialUnknown': 'لا توجد بيانات اعتماد لهذا الموصل بهذا المرجع.',
  'cred.v.externalRef': 'استخدم من 1 إلى 120 حرفًا أو رقمًا أو مسافة أو . _ : / -.',
  'cred.v.badgeMandatory': 'تعرض الشارة دائمًا اسم الزائر ووقت انتهاء الصلاحية والمرجع.',
  // ------------------------------------------------------------ workspace (Badges & access)
  'cred.intro': "الحيازة المادية والدخول المنطقي حقيقتان منفصلتان. المغادرة أو إعادة البطاقة أو إقرار المزوّد لا يؤكد انتهاء الدخول.",
  'cred.inventorySub': "تبقى البطاقات المعادة محتجزة حتى يتأكد أن دخولها غير نشط.",
  'cred.heldUntilInactive': "محتجزة حتى يتأكد أن الدخول غير نشط",
  'cred.tab.recovery': "قائمة المعالجة",
  'cred.tab.access': "الدخول المؤقت",
  'cred.tab.inventory': "المخزون المادي",
  'cred.tab.badges': "طباعة الشارات",
  'cred.tab.scope': "نطاق الدخول",
  'cred.recovery.title': "عمليات دخول غير مؤكدة",
  'cred.recovery.sub': "يلزم تأكيد بالقراءة العكسية قبل إغلاق الاستثناء.",
  'cred.recovery.empty': "لا توجد عمليات دخول غير مؤكدة أو فاشلة.",
  'cred.recovery.note': "«غير معروفة» تعني أن نظام التحكم بالدخول لم يؤكد النتيجة. اقرأ العملية نفسها عكسيًا قبل إرسال أي شيء مجددًا؛ تُسجَّل المغادرة المرصودة بشكل مستقل.",
  'cred.col.visitor': "الزائر",
  'cred.col.presence': "الحضور",
  'cred.col.credential': "بيانات الاعتماد",
  'cred.col.operation': "العملية",
  'cred.col.card': "البطاقة",
  'cred.col.owner': "المسؤول",
  'cred.col.action': "الإجراء",
  'cred.col.carrier': "الحامل",
  'cred.col.validity': "الصلاحية",
  'cred.col.trigger': "المسبّب",
  'cred.col.result': "النتيجة",
  'cred.col.reference': "مرجع العملية",
  'cred.attempts': { zero: "لا محاولات", one: "محاولة واحدة", two: "محاولتان", few: "{count} محاولات", many: "{count} محاولة", other: "{count} محاولة" },
  'cred.unowned': "غير مسندة",
  'cred.claim': "تولَّ المسؤولية",
  'cred.readBack': "قراءة عكسية",
  'cred.decide': "سجّل قرارًا",
  'cred.readBackRunning': "جارٍ القراءة العكسية…",
  'cred.operatorHandles': "يتولى مشغّل المنصة المعالجة",
  'cred.decision.title': "تسجيل قرار معالجة",
  'cred.decision.warning': "سجّل فقط ما تأكدت منه في نظام التحكم بالدخول نفسه. هذا القرار مُدقَّق ولا يمكن التراجع عنه.",
  'cred.decision.choose': "القرار",
  'cred.decision.note': "ما الذي تحققت منه",
  'cred.decision.noteHint': "مثال: «تم التحقق من وحدة التحكم بالدخول الساعة 14:05 — البطاقة معطّلة.»",
  'cred.decision.record': "سجّل القرار",
  'cred.decision.confirmed_revoked': "تأكد إلغاء الدخول",
  'cred.decision.retry_revoke': "أرسل الإلغاء مجددًا (بيانات الاعتماد نفسها)",
  'cred.decision.not_issued': "تأكد عدم الإصدار",
  'cred.list.title': "بيانات الاعتماد المؤقتة",
  'cred.list.sub': "دخول منطقي للزوار، منفصل عن الحضور وحيازة البطاقات.",
  'cred.list.view': "عرض",
  'cred.list.live': "الحالية والحديثة",
  'cred.list.all': "الكل",
  'cred.list.empty': "لا توجد بيانات اعتماد بعد.",
  'cred.list.issueOnly': "يمكنك طلب بيانات الاعتماد؛ السجل متاح للمشغّلين.",
  'cred.issue.open': "طلب بيانات اعتماد",
  'cred.issue.title': "طلب دخول مؤقت",
  'cred.issue.sub': "يقتصر الدخول على المناطق والفترة المعتمدة. لا يُصدر شيء حتى يؤكده نظام التحكم بالدخول.",
  'cred.issue.search': "ابحث عن زائر",
  'cred.issue.searchHint': "الاسم أو مرجع الزيارة (الزيارات المقدّمة خلال الأيام السبعة القادمة).",
  'cred.issue.noCandidates': "لا يوجد زوار مطابقون.",
  'cred.issue.change': "تغيير",
  'cred.issue.token': "الحامل",
  'cred.issue.notAvailable': "غير متاح هنا",
  'cred.issue.zones': "المناطق",
  'cred.issue.zonesHint': "لا يمكن اختيار إلا المناطق التي تشملها موافقة الزيارة. المنطقة بلا ربط تمنع الطلب — ولا تُستبدل أبدًا بمستوى أوسع.",
  'cred.issue.noZones': "لا وجهة للزيارة، لذا لا توجد منطقة معتمدة.",
  'cred.issue.schedule': "الجدول",
  'cred.issue.blocked': "هذا الطلب محجوب:",
  'cred.issue.ready': "جاهز للطلب. ستظهر النتيجة عند رد نظام التحكم بالدخول.",
  'cred.issue.submit': "اطلب بيانات الاعتماد",
  'cred.zone.granted': "مربوطة",
  'cred.zone.unmapped': "بلا ربط",
  'cred.zone.not_approved': "غير معتمدة",
  'cred.schedule.validity': "الصلاحية",
  'cred.schedule.daily': "الفترة اليومية",
  'cred.schedule.siteTime': "المنطقة الزمنية للموقع",
  'cred.schedule.conversion': "تحويل المزوّد",
  'cred.schedule.exact': "مطابق",
  'cred.schedule.narrowed': "ضُيّق إلى خطوة زمن المزوّد (لا يُوسَّع أبدًا)",
  'cred.schedule.activation': "التفعيل",
  'cred.scheduledFor': "مجدول في {at}؛ تُفحص الأهلية مجددًا حينها.",
  'cred.scheduleProblem.no_remaining_window': "انتهت فترة الزيارة.",
  'cred.scheduleProblem.mode_unsupported': "لا يستطيع نظام التحكم بالدخول حفظ فترة يومية لعدة أيام؛ سيضطر لمنح دخول على مدار الساعة، لذا يُرفض الطلب.",
  'cred.scheduleProblem.too_long': "الفترة أطول مما يسمح به نظام التحكم بالدخول.",
  'cred.scheduleProblem.not_representable': "لا يمكن تمثيل الفترة بدقة، والتضييق غير مسموح في هذا الموقع.",
  'cred.scheduleProblem.empty_after_rounding': "لا يبقى شيء من الفترة بعد التحويل إلى خطوة زمن المزوّد.",
  'cred.blocker.visit_not_submitted': "الزيارة غير مقدّمة.",
  'cred.blocker.approval_not_granted': "الزيارة غير معتمدة.",
  'cred.blocker.participant_removed': "أُزيل الشخص من الزيارة.",
  'cred.blocker.window_ended': "انتهت فترة الزيارة.",
  'cred.blocker.departed': "غادر الزائر بالفعل.",
  'cred.blocker.contractor_not_eligible': "متطلبات المقاول غير مستوفاة.",
  'cred.blocker.credential_exists': "لدى هذا الشخص بيانات اعتماد قد تمنح الدخول.",
  'cred.blocker.prior_unresolved': "إلغاء بيانات اعتماد سابقة ما زال معلقًا أو غير معروف.",
  'cred.blocker.no_connector': "لا يوجد موصل دخول نشط في هذا الموقع.",
  'cred.blocker.visitor_type_no_credential': "لا يحصل هذا النوع من الزوار على بيانات اعتماد للدخول.",
  'cred.blocker.token_type_not_allowed': "هذا الحامل غير مسموح في هذا الموقع.",
  'cred.blocker.token_type_unsupported': "نظام التحكم بالدخول لا يدعم هذا الحامل.",
  'cred.blocker.card_not_assigned': "خصّص بطاقة مادية لهذا الزائر أولًا.",
  'cred.blocker.card_in_use': "تحمل هذه البطاقة بيانات اعتماد بالفعل.",
  'cred.blocker.zone_not_approved': "منطقة مختارة خارج موافقة الزيارة.",
  'cred.blocker.zone_mapping_missing': "لا يوجد ربط دخول معتمد لإحدى المناطق.",
  'cred.blocker.no_zone': "لم تُختر أي منطقة.",
  'cred.blocker.too_many_zones': "عدد المناطق أكبر مما يسمح به نظام التحكم بالدخول.",
  'cred.blocker.schedule_unrepresentable': "لا يستطيع نظام التحكم بالدخول تمثيل الفترة.",
  'cred.token.card': "بطاقة مادية",
  'cred.token.pin': "رمز PIN (يصدره المزوّد)",
  'cred.token.qr': "رمز QR (يصدره المزوّد)",
  'cred.token.mobile': "بيانات اعتماد على الهاتف",
  'cred.kind.issue': "إصدار",
  'cred.kind.revocation': "إلغاء",
  'cred.op.queued': "في الانتظار",
  'cred.op.dispatched': "أُرسلت",
  'cred.op.acknowledged': "تم الإقرار",
  'cred.op.confirmed': "مؤكدة",
  'cred.op.failed': "فشلت",
  'cred.op.unknown': "غير معروفة",
  'cred.op.reconciling': "جارٍ القراءة العكسية",
  'cred.trigger.request': "طلب",
  'cred.trigger.retry': "إعادة",
  'cred.trigger.departure': "مغادرة",
  'cred.trigger.card_lost': "فقدان بطاقة",
  'cred.trigger.cancellation': "إلغاء الزيارة",
  'cred.trigger.expiry': "انتهاء الزيارة",
  'cred.trigger.removal': "إزالة من الزيارة",
  'cred.trigger.manual': "طلب يدوي",
  'cred.trigger.reconcile': "معالجة",
  'cred.resolution.read_back': "أُكّد بالقراءة العكسية",
  'cred.resolution.manual_confirmed_revoked': "أكّد شخص إلغاء الدخول",
  'cred.resolution.manual_not_issued': "أكّد شخص عدم الإصدار",
  'cred.resolution.superseded': "حلّ محلها غيرها",
  'cred.resolution.retried': "أُرسلت مجددًا",
  'cred.reason.timeout': "لا رد في الوقت المحدد",
  'cred.reason.confirmed': "مؤكدة",
  'cred.reason.rejected': "رفضها المزوّد",
  'cred.reason.revoke_rejected': "رُفض الإلغاء — قد يبقى الدخول قائمًا",
  'cred.reason.scope_mismatch': "أكّد المزوّد نطاقًا أوسع من المطلوب",
  'cred.reason.redelivered_after_dispatch': "انقطعت بعد الإرسال؛ اقرأ عكسيًا قبل الإعادة",
  'cred.reason.read_back_active': "القراءة العكسية: نشطة",
  'cred.reason.read_back_absent': "القراءة العكسية: غير موجودة",
  'cred.reason.read_back_revoked': "القراءة العكسية: ملغاة",
  'cred.reason.read_back_still_active': "القراءة العكسية: ما زالت نشطة",
  'cred.reason.read_back_unavailable': "القراءة العكسية غير متاحة",
  'cred.reason.read_back_not_supported': "القراءة العكسية غير مدعومة",
  'cred.reason.adapter_unavailable': "المحوّل غير متاح",
  'cred.reason.approval_not_granted': "سُحبت الموافقة قبل التفعيل",
  'cred.reason.contractor_not_eligible': "فشلت متطلبات المقاول قبل التفعيل",
  'cred.reason.revoked_before_activation': "أُلغيت قبل التفعيل",
  'cred.reason.request': "طُلبت",
  'cred.reason.retry': "طُلبت مجددًا",
  'cred.reason.revoke': "طُلب الإلغاء",
  'cred.reason.manual_confirmed_revoked': "أكّد شخص إلغاء الدخول",
  'cred.reason.manual_not_issued': "أكّد شخص عدم الإصدار",
  'cred.reason.transport': "فشل الاتصال",
  'cred.reason.credential_changed': "تغيّرت بيانات الاعتماد في الأثناء",
  'cred.reason.zone_mapping_changed': "تغيّر ربط المناطق قبل التفعيل",
  'cred.reason.window_ended': "انتهت الفترة قبل التفعيل",
  'cred.reason.connector_inactive': "الموصل معطّل",
  'cred.reason.provider_schedule_ended': "انتهى جدول المزوّد",
  'cred.reason.nothing_to_revoke': "لم يبق ما يُلغى",
  'cred.reason.credential_not_requested': "لم تعد مطلوبة",
  'cred.reason.visit_not_submitted': "لم تعد الزيارة مقدّمة",
  'cred.reason.participant_removed': "أُزيل من الزيارة",
  'cred.view': "عرض",
  'cred.retry': "اطلب مجددًا (بيانات الاعتماد نفسها)",
  'cred.system': "النظام",
  'cred.detail.title': "بيانات اعتماد مؤقتة",
  'cred.detail.independent': "كل سطر أدناه حقيقة مستقلة. يُعرض الحضور وحيازة البطاقة للسياق؛ ولا يغيّر أيٌّ منهما بيانات الاعتماد.",
  'cred.detail.confirmed': "مؤكد من المزوّد",
  'cred.detail.notConfirmed': "غير مؤكد",
  'cred.detail.connector': "الموصل",
  'cred.detail.revokeRequested': "طُلب الإلغاء",
  'cred.detail.operations': "عمليات المزوّد",
  'cred.detail.history': "سجل دورة الحياة",
  'cred.event.state': "تغيّرت الحالة",
  'cred.event.issue_queued': "الإصدار في الانتظار",
  'cred.event.revocation_queued': "الإلغاء في الانتظار",
  'cred.event.issue_dispatched': "أُرسل الإصدار",
  'cred.event.revocation_dispatched': "أُرسل الإلغاء",
  'cred.event.revoke_requested': "طُلب الإلغاء",
  'cred.event.recovery_decision': "قرار معالجة",
  'cred.revoke.reason': "سبب الإلغاء",
  'cred.revoke.hint': "يذهب الطلب إلى نظام التحكم بالدخول؛ وتظهر النتيجة عند رده.",
  'cred.revoke.submit': "اطلب الإلغاء",
  'cred.events.title': "أحداث الدخول",
  'cred.events.sub': "أحداث الأبواب والمناطق التي يبلّغ عنها الموصل، بحسب وقت حدوثها. تُميَّز الأحداث المتأخرة؛ ولا تغيّر الحضور أبدًا.",
  'cred.events.empty': "لا توجد أحداث دخول.",
  'cred.events.occurred': "وقت الحدوث",
  'cred.events.received': "وقت الاستلام",
  'cred.events.late': "متأخر",
  'cred.events.door': "الباب / المنطقة",
  'cred.events.result': "النتيجة",
  'cred.events.correlation': "المطابقة",
  'cred.direction.entry': "دخول",
  'cred.direction.exit': "خروج",
  'cred.direction.unknown': "اتجاه غير معروف",
  'cred.result.granted': "سُمح",
  'cred.result.denied': "رُفض",
  'cred.confidence.exact': "مطابقة لبيانات اعتماد",
  'cred.confidence.outside_validity': "بيانات اعتماد خارج صلاحيتها",
  'cred.confidence.none': "لا بيانات اعتماد مطابقة",
  'cred.badge.bandAccess': "دخول مؤقت",
  'cred.badge.bandEscort': "يلزم مرافق — ليست بطاقة دخول",
  'cred.badge.destination': "الوجهة",
  'cred.badge.category': "نوع الزائر",
  'cred.badge.photoPlaceholder': "لا صورة",
  'cred.badge.qrLabel': "المرجع {reference} كرمز QR (ليس بيانات دخول)",
  'cred.badges.title': "قوالب الشارات",
  'cred.badges.sub': "محتوى الشارة بحسب الموقع ونوع الزائر وحالة الدخول. لا يُطبع إلا الحقول المعتمدة.",
  'cred.badges.new': "قالب جديد",
  'cred.badges.empty': "لا توجد قوالب بعد — تستخدم الشارات التخطيط المدمج.",
  'cred.badges.col.name': "القالب",
  'cred.badges.col.appliesTo': "ينطبق على",
  'cred.badges.col.status': "الحالة",
  'cred.badges.version': "الإصدار {n}",
  'cred.badges.thisSite': "هذا الموقع",
  'cred.badges.allSites': "كل المواقع",
  'cred.badges.anyCategory': "أي نوع زائر",
  'cred.badges.edit': "تعديل",
  'cred.badges.publish': "نشر",
  'cred.badges.discard': "تجاهل",
  'cred.badges.access.any': "أي حالة دخول",
  'cred.badges.access.with_credential': "مع دخول مؤقت",
  'cred.badges.access.without_credential': "بدون دخول مؤقت",
  'cred.badges.status.draft': "مسودة",
  'cred.badges.status.published': "منشور",
  'cred.badges.status.retired': "متقاعد",
  'cred.badges.status.discarded': "متجاهَل",
  'cred.badges.note': "الطباعة لا تُصدر بيانات دخول أبدًا. إعادة الطباعة تحتفظ بهوية الشارة.",
  'cred.badges.designerSub': "لا يمكن تغيير الإصدارات المنشورة؛ والنشر يستبدل الإصدار السابق للنطاق نفسه.",
  'cred.badges.f.name': "الاسم",
  'cred.badges.f.scope': "النطاق",
  'cred.badges.f.category': "رمز نوع الزائر",
  'cred.badges.f.categoryHint': "اتركه فارغًا لأي نوع زائر.",
  'cred.badges.f.access': "حالة الدخول",
  'cred.badges.f.size': "المقاس",
  'cred.badges.f.accent': "لون التمييز",
  'cred.badges.f.fields': "الحقول",
  'cred.badges.f.fieldsHint': "يُطبع الاسم وانتهاء الصلاحية والمرجع دائمًا. لا أرقام وثائق هوية ولا تواريخ ميلاد ولا ملاحظات خاصة.",
  'cred.badges.f.statusBand': "أظهر شريط حالة الدخول",
  'cred.badges.size.cr80': "بطاقة (CR80)",
  'cred.badges.size.a6': "ملصق (A6)",
  'cred.badges.saveDraft': "احفظ المسودة",
  'cred.badges.preview': "معاينة",
  'cred.badges.sample': "اسم تجريبي",
  'cred.badges.sampleLong': "اسم عربي طويل",
  'cred.badges.sampleShort': "اسم قصير",
  'cred.badges.sampleSite': "موقع تجريبي",
  'cred.badges.previewNote': "تلتف الأسماء الطويلة وتُختصر؛ ويبقى وقت انتهاء الصلاحية ورمز QR ظاهرين دائمًا.",
  'cred.badges.field.visitorName': "اسم الزائر",
  'cred.badges.field.organisation': "الجهة",
  'cred.badges.field.hostName': "المضيف",
  'cred.badges.field.siteName': "الموقع",
  'cred.badges.field.destination': "الوجهة",
  'cred.badges.field.validUntil': "صالحة حتى",
  'cred.badges.field.reference': "المرجع",
  'cred.badges.field.category': "نوع الزائر",
  'cred.badges.field.photo': "الصورة (عنصر نائب عند غيابها)",
  'cred.badges.field.referenceQr': "رمز QR للمرجع (ليس بيانات دخول)",
  'cred.scope.standalone': "تعمل الزيارات والوصول والمغادرة دون أي نظام تحكم بالدخول. الموصلات تضيف الدخول المؤقت فقط.",
  'cred.scope.connector': "موصل الدخول",
  'cred.scope.connectorSub': "المحوّل الذي يستخدمه هذا الموقع وقدراته المعتمدة وقواعد بيانات الاعتماد للموقع.",
  'cred.scope.none': "لا يوجد موصل دخول نشط في هذا الموقع.",
  'cred.scope.addSimulator': "أضف محاكي التطوير",
  'cred.scope.simulatorName': "محاكي الدخول للتطوير",
  'cred.scope.capabilities': "القدرات",
  'cred.scope.disable': "عطّل الموصل",
  'cred.connector.active': "نشط",
  'cred.connector.disabled': "معطّل",
  'cred.rules.tokens': "الحوامل المسموحة في هذا الموقع",
  'cred.rules.enclosing': "ضمّن المناطق المحيطة بالوجهة (المبنى، الطابق)",
  'cred.rules.narrowing': "ضيّق الفترات التي لا يستطيع المزوّد حفظها بدقة (لا توسيع أبدًا)",
  'cred.rules.lead': "فعّل قبل الفترة بهذا العدد من الدقائق",
  'cred.rules.expiry': "عند انتهاء الزيارة",
  'cred.rules.expiry.revoke': "اطلب الإلغاء",
  'cred.rules.expiry.trust': "اعتبر جدول المزوّد المؤكد انتهاءً",
  'cred.rules.timeout': "مهلة المزوّد (ملّي ثانية)",
  'cred.rules.autoReadBack': "قراءة عكسية تلقائية بعد (ثوانٍ، 0 = معطلة)",
  'cred.sim.title': "سلوك المحاكي",
  'cred.sim.hint': "للتطوير فقط. يتيح رؤية كل النتائج؛ ولا يُتصل بأي نظام تحكم بالدخول حقيقي.",
  'cred.sim.issue': "الإصدار",
  'cred.sim.revoke': "الإلغاء",
  'cred.sim.readBack': "القراءة العكسية",
  'cred.sim.readBack.normal': "متاحة",
  'cred.sim.readBack.unavailable': "غير متاحة",
  'cred.sim.b.succeed': "نجاح",
  'cred.sim.b.reject': "رفض",
  'cred.sim.b.timeout': "انتهاء المهلة (دون تطبيق)",
  'cred.sim.b.late': "تطبيق مع رد متأخر",
  'cred.sim.b.silent': "لا رد أبدًا",
  'cred.sim.b.broaden': "تأكيد نطاق أوسع",
  'cred.sim.eventCredential': "مرجع بيانات الاعتماد لدى المزوّد",
  'cred.sim.eventDoor': "الباب / مستوى الدخول",
  'cred.sim.sendEvent': "أرسل حدثًا محاكًى",
  'cred.mapping.title': "ربط المناطق",
  'cred.mapping.sub': "يُربط كل موقع بمستوى دخول واحد في الموصل. لا يمكن منح منطقة بلا ربط.",
  'cred.mapping.location': "الموقع",
  'cred.mapping.externalRef': "مرجع مستوى الدخول",
  'cred.mapping.add': "أضف ربطًا",
  'cred.mapping.empty': "لا توجد روابط بعد.",
  'cred.mapping.retire': "إيقاف",
  'cred.mapping.active': "نشط",
  'cred.mapping.retired': "متقاعد",
  'cred.catalogue.title': "كتالوج الموصلات",
  'cred.catalogue.sub': "تبقى المنصات المسماة غير متاحة حتى يجتاز محوّلها اختبارات التوافق.",
  'cred.catalogue.platform': "المنصة",
  'cred.catalogue.availability': "التوفر",
  'cred.catalogue.validated': "الإصدارات المعتمدة",
  'cred.catalogue.limitations': "القيود",
  'cred.catalogue.development': "للتطوير فقط",
  'cred.catalogue.unavailable': "غير متاحة",
  'cred.catalogue.simulator': "محاكٍ للتطوير والاختبارات؛ مرفوض في بيئة الإنتاج.",
  'cred.catalogue.unvalidated': "لا محوّل معتمد: يحتاج بيئة اختبار من المورّد واختبارات توافق (قرار مفتوح H-05).",
};
